import React from 'react';

import { Text } from '@change/ds-core-ui';

export const TopImpactStoryBadge: React.FC<{
	labelTitle: string;
	labelText: string;
	dataTestId: string;
}> = ({ labelTitle, labelText, dataTestId }) => {
	return (
		<div data-testid={dataTestId} className="absolute left-1/2 top-full z-20 -translate-x-1/2 transform" aria-hidden>
			<div className="border-surface-neutral -mt-7 inline-block min-w-[8rem] whitespace-nowrap rounded-full border-2 bg-surface-accent px-4 py-2 text-center text-content-inverse">
				<Text as="p" fontWeight="bold" size="small" className="-mb-1">
					{labelTitle}
				</Text>
				<Text size="small">{labelText}</Text>
			</div>
		</div>
	);
};
